import React from "react"
import { Breadcrumb, BreadcrumbItem, Container, Row, Col } from "reactstrap"
import { FaPhone, FaEnvelope, FaFax } from "react-icons/fa"
import Layout from "./../components/layout"
import SEO from "./../components/seo"
import "../style/support.css"

function Products() {
  return (
    <Layout>
      <SEO />
      <Breadcrumb className="breadCrumb">
        <BreadcrumbItem>
          <a className="breadCrumbLinks" href="/">
            Home
          </a>
        </BreadcrumbItem>
        <BreadcrumbItem active>Contact & Support</BreadcrumbItem>
      </Breadcrumb>
      <Container className="supportContainer" style={{ textAlign: "center" }}>
        <Row>
          <Col>
            <h1>Contact & Support</h1>
          </Col>
        </Row>
        <Row id="hours-row">
          <Col xs="0" sm="2"></Col>
          <Col xs="12" sm="8">
            <section
              style={{
                color: "white",
                backgroundColor: "#454851",
                padding: "8px",
              }}
            >
              Standard North American office hours are 8AM-4:30PM EST, Monday to
              Friday
              <br />
              Urgent support calls are welcome any time, and always addressed
              ASAP if missed
            </section>
          </Col>
          <Col xs="0" sm="2"></Col>
        </Row>
        <Row>
          <Col>
            <p className="email-p">
              {/* <strong>Email</strong>
          <br /> */}
              <FaEnvelope />
              <a
                className="emailLink"
                href="mailto: tech.support@intnlsoftwareproducts.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                {" "}
                tech.support@intnlsoftwareproducts.com
              </a>
            </p>
          </Col>
        </Row>
        <Row>
          <Col className="supportColsLeft" xs="4" sm="5">
            <p>
              <strong>North America</strong>
            </p>
          </Col>
          <Col className="supportColsRight" xs="8" sm="7">
            <p>
              {/* Tel: */}
              <FaPhone />
              <a href="tel:+18002957608" className="phoneLinks">
                {" "}
                1-800-295-7608
              </a>{" "}
              Ext: 4 or Ext: 8
              <br />
              <FaFax />
              {/* Fax:  */} 1-800-295-7609
            </p>
          </Col>
        </Row>
        <Row>
          <Col className="supportColsLeft" xs="4" sm="5">
            <p>
              <strong>Worldwide</strong>
            </p>
          </Col>
          <Col className="supportColsRight" xs="8" sm="7">
            <p>
              {/* Tel:{" "} */}
              <FaPhone />
              <a href="tel:+14165935578" className="phoneLinks">
                {" "}
                1-416-593-5578{" "}
              </a>
              Ext: 4 or Ext: 8, or Your Local ISP Rep
              <br />
              {/* Fax:  */}
              <FaFax /> 1-416-593-5579, or Your Local ISP Rep
            </p>
          </Col>
        </Row>
        <Row>
          <Col className="supportColsLeft" xs="4" sm="5"></Col>
          <Col className="supportColsRight" xs="8" sm="7"></Col>
        </Row>
        <Row>
          <Col className="supportColsLeft" xs="4" sm="5">
            <p>
              <strong>Urgent (after hours)</strong>
            </p>
          </Col>
          <Col className="supportColsRight" xs="8" sm="7"></Col>
        </Row>
        <Row>
          <Col className="supportColsLeft" xs="4" sm="5">
            <p>
              <strong>North America</strong>
            </p>
          </Col>
          <Col className="supportColsRight" xs="8" sm="7">
            <p>
              {/* Tel:{" "} */}
              <FaPhone />
              <a href="tel:+14168023706" className="phoneLinks">
                {" "}
                1-416-802-3706
              </a>
            </p>
          </Col>
        </Row>
        <Row>
          <Col className="supportColsLeft" xs="4" sm="5">
            <p>
              <strong>Worldwide</strong>
            </p>
          </Col>
          <Col className="supportColsRight" xs="8" sm="7">
            <p>
              Your Local ISP Rep or {/* Tel: */}
              <FaPhone />{" "}
              <a href="tel:+14168023706" className="phoneLinks">
                1-416-802-3706
              </a>
            </p>
          </Col>
        </Row>
        <Row>
          <Col className="supportColsLeft" xs="4" sm="5"></Col>
          <Col className="supportColsRight" xs="8" sm="7"></Col>
        </Row>
      </Container>
    </Layout>
  )
}

export default Products
